export const GET_HOME_CONTENT = "GET_HOME_CONTENT";
export const UPDATE_HOME_CONTENT_REQUEST = "UPDATE_HOME_CONTENT_REQUEST";
export const UPDATE_HOME_CONTENT_SUCCESS = "UPDATE_HOME_CONTENT_SUCCESS";
export const UPDATE_HOME_CONTENT_RESET = "UPDATE_HOME_CONTENT_RESET";
export const UPDATE_HOME_CONTENT_FAILED = "UPDATE_HOME_CONTENT_FAILED";

export const CLEAR_ERRORS = 'CLEAR_ERRORS';